export const UPDATE_THEME = 'theme.UPDATE_THEME';
export const SWITCH_NIGHT_MODE = 'theme.SWITCH_NIGHT_MODE';